import type { StrapiQuoteBlock } from "../types";

interface QuoteBlockProps {
  block: StrapiQuoteBlock;
}

export const QuoteBlock = ({ block }: QuoteBlockProps) => {
  return (
    <blockquote className="border-l-4 border-primary pl-6 py-4 bg-muted/50 rounded-lg">
      {block.title && (
        <p className="text-lg font-semibold mb-2">{block.title}</p>
      )}
      <p className="italic">{block.body}</p>
    </blockquote>
  );
};
